import { useMemo, useRef, useState } from 'react'
import { Button, Tab, Tabs } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import LaboratoryCollectionPointForm from '../components/LaboratoryCollectionPointForm'
import CollectionSlots from './collectionPoint/CollectionSlots'

const LaboratoryCollectionPoint = () => {
  const navigate = useNavigate()
  const { laboratoryId, collectionPointId } = useParams()

  const numericLaboratoryId = useMemo(
    () => (laboratoryId ? parseInt(laboratoryId, 10) : undefined),
    [laboratoryId]
  )

  const numericCollectionPointId = useMemo(
    () => (collectionPointId ? parseInt(collectionPointId, 10) : undefined),
    [collectionPointId]
  )

  const handleSuccess = () => {
    if (numericLaboratoryId) {
      navigate(`/laboratory/${numericLaboratoryId}`)
    } else {
      navigate(-1)
    }
  }

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-0">Punkt pobrań</h2>
          {numericCollectionPointId ? (
            <p className="text-muted mb-0">Edycja punktu</p>
          ) : (
            <p className="text-muted mb-0">Dodawanie nowego punktu</p>
          )}
        </div>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Wróć
        </Button>
      </div>

      {numericCollectionPointId ? (
        <Tabs defaultActiveKey="settings" className="mb-3">
          <Tab eventKey="settings" title="Ustawienia">
            <LaboratoryCollectionPointForm
              id={numericCollectionPointId}
              laboratoryId={numericLaboratoryId}
              onSuccess={handleSuccess}
            />
          </Tab>
          <Tab eventKey="collectionSlots" title="Terminarz">
            <CollectionSlots
              id={numericCollectionPointId}
            />
          </Tab>
        </Tabs>
      ) : (
        <LaboratoryCollectionPointForm
          id={numericCollectionPointId}
          laboratoryId={numericLaboratoryId}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  )
}

export default LaboratoryCollectionPoint
